import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoKi: CultureInfo = {
  name: 'ki',
  displayName: 'Gikuyu',
  iso3LanguageCode: 'kik',
  iso2LanguageCode: 'ki',
  ietfLanguageTag: 'ki',
  parent: null
};
